<template>
  <div>
    <SubmissionFormView
      :eventType="triggerEventType"
      v-show="showUSForm"
    ></SubmissionFormView>
    <EUSubmissionFormView
      :euEventType="triggerEuEventType"
      v-show="showEUForm"
    ></EUSubmissionFormView>
  </div>
</template>

<script>
import SubmissionFormView from "../views/SubmissionFormView.vue";
import EUSubmissionFormView from "../views/EUSubmissionFormView.vue";
export default {
  name: "ManageSupplierUsersView",
  data() {
    return {
      triggerEventType: "",
      triggerEuEventType: "",
      viewOnlyEvent: "",
      showUSForm: false,
      showEUForm: false
    };
  },
  components: { SubmissionFormView, EUSubmissionFormView },
  mounted() {
    if (this.$route.path.toLowerCase().includes("eu")) {
      this.showEUForm = true;
      this.showUSForm = false;
      if (sessionStorage.getItem("createRequestEUFromSe")) {
        this.triggerEuEventType = "createRequestEu";
      }
      //eu region requests from SEP
      else if (sessionStorage.getItem("editRequestFromSeEu")) {
        this.triggerEuEventType = {
          editRequest: sessionStorage.getItem("editRequestFromSeEu")
        };
      } else if (sessionStorage.getItem("viewRequestFromSeEu")) {
        this.triggerEuEventType = {
          viewRequest: sessionStorage.getItem("viewRequestFromSeEu")
        };
      } else if (sessionStorage.getItem("reViewRequestFromSeEu")) {
        this.triggerEuEventType = {
          reViewRequest: sessionStorage.getItem("reViewRequestFromSeEu")
        };
      }
    } else {
      this.showEUForm = false;
      this.showUSForm = true;
      this.checkBuildApi();
    }
  },
  methods: {
    checkBuildApi() {
      var newItemSubmissionComponentScope = this;
      newItemSubmissionComponentScope.isLoading = true;
      newItemSubmissionComponentScope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}isBuildInProgress`,
          method: "GET"
        })
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          if (response.data.toLowerCase() === "yes") {
            //take user to maintainance page
            newItemSubmissionComponentScope.$router.push({
              path: "/maintainancePage"
            });
          } else {
            //us region requests from SEP
            if (sessionStorage.getItem("createRequestFromSe")) {
              newItemSubmissionComponentScope.triggerEventType =
                "createRequest";
            } else if (sessionStorage.getItem("editRequestFromSe")) {
              newItemSubmissionComponentScope.triggerEventType = {
                editRequest: sessionStorage.getItem("editRequestFromSe")
              };
            } else if (sessionStorage.getItem("viewRequestFromSe")) {
              newItemSubmissionComponentScope.triggerEventType = {
                viewRequest: sessionStorage.getItem("viewRequestFromSe")
              };
            } else if (sessionStorage.getItem("createRequestEUFromSe")) {
              newItemSubmissionComponentScope.triggerEventType =
                "createRequestEu";
            }
            //eu region requests from SEP
            else if (sessionStorage.getItem("editRequestFromSeEu")) {
              newItemSubmissionComponentScope.triggerEuEventType = {
                editRequest: sessionStorage.getItem("editRequestFromSeEu")
              };
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `A problem occurred while loading data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    }
  }
};
</script>

<style scoped>
div {
  margin: 25px;
}
</style>
